module.exports = __webpack_public_path__ + "static/fast-breadcrumb-basic-f483b2d5c6d916b722884dcb43f010ac.png";